import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

export default function AccountCards({ accounts, formatCurrency, handleCopyClick, copiedAccount, userData }) {
  const getAccountLabel = (type) => {
    if (type === 'Current' || type === 'Checking') return 'Current account';
    return type || 'Account';
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {accounts.map((acc) => {
        const balance = acc.available ?? acc.balance ?? 0;
        const routingNumber = acc.routingNumber || acc.sortCode || '021000021';
        const lastFour = acc.accountNumber ? String(acc.accountNumber).slice(-4) : '****';

        return (
          <div
            key={acc.type}
            className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-800 to-slate-900 dark:from-primary-900 dark:to-slate-800 p-5 shadow-lg"
          >
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,255,255,0.08)_0%,transparent_50%)]" aria-hidden />
            <div className="relative">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-xs font-medium text-slate-400 uppercase tracking-wider">{getAccountLabel(acc.type)}</p>
                  <p className="mt-1 text-2xl font-bold text-white tracking-tight">{formatCurrency(balance)}</p>
                  <p className="mt-0.5 text-xs text-slate-400">{userData?.name || 'Account holder'}</p>
                </div>
                <a
                  href="#transfer-section"
                  className="shrink-0 flex items-center gap-1 rounded-lg bg-white/10 px-2.5 py-1.5 text-xs font-medium text-white hover:bg-white/20 transition-colors"
                >
                  Transfer <ChevronRightIcon className="h-3.5 w-3.5" />
                </a>
              </div>
              <div className="mt-5 flex flex-wrap items-center gap-4 border-t border-white/10 pt-4">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-slate-500">Routing number</span>
                  <span className="font-mono text-sm font-medium text-slate-300">{routingNumber}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-slate-500">Account</span>
                  <span className="font-mono text-sm font-medium text-slate-300">****{lastFour}</span>
                  <button
                    type="button"
                    onClick={() => handleCopyClick(acc.accountNumber, acc.type)}
                    className="rounded p-1 text-slate-400 hover:bg-white/10 hover:text-white transition-colors"
                    title="Copy account number"
                  >
                    {copiedAccount === acc.type ? (
                      <span className="text-emerald-400 text-xs">Copied</span>
                    ) : (
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h2m8 0h2a2 2 0 012 2v2m2 4v6a2 2 0 01-2 2h-8a2 2 0 01-2-2v-8z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
